import Head from 'next/head';
import Layout from 'components/layout';
import Preview from 'components/preview';
// import useSWR, { SWRConfig } from 'swr';
export default function Home() {
  return (
    <Layout>
      <Head>
        <title>关于加强安全专项治理的说明</title>
      </Head>
      <section>
        <Preview
          detail={{
            id: '1',
            intro: '关于加强安全专项治理的说明',
            content:
              '<p>&nbsp; &nbsp; &nbsp; &nbsp; 4月18日，我司发现小鱼专有云视频平台被非法攻击，立即紧急组织技术团队，协同安全专家进行排查，目前已及时处理并修复。 就此事件，我司已与公安机关联系并沟通。</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; 产品安全是云视频的头等大事，我司已成立安全专项小组，并聘请安全专家团队，全力以赴为用户提供最可靠的安全保障。</p>\n<p><br /><br /></p>\n<p class="sign no-mb" style="text-align: right;">2021年4月20日</p>',
          }}
        />
      </section>
    </Layout>
  );
}
